<template>
  <div id="projects-and-friends" :class="{ expanded: expanded }">
    <section 
      id="projects"
      :class="{
        loaded: projects.length > 0
      }"
    >
      <p class="title"> {{ projectsTitle }} </p>
      <div class="content">
        <ul>
           <Project 
            ref="projects"
            v-for="project in projects" 
            :key="project.slug"
            :slug="project.slug"
            :title="project.title"
            :StartDate="project.StartDate"
            :EndDate="project.EndDate"
            :body="project.cleanBody"
            :role="project.role"
            :relationship="project.Relationship"
            :collaborators="project.collaborators"
            @projectHovered="handleProjectHoverIn($event)"
            @projectUnhovered="handleProjectHoverOut($event)"
            @projectClicked="handleProjectClick($event)"
          />
        </ul>
      </div>
    </section>
    <section 
      id="collaborators"
      :class="{
        loaded: collaborators.length > 0
      }"
    >
      <p class="title"> {{ collaboratorsTitle }} </p>
      <div class="content">
        <ul>
          <Collaborator
            ref="collaborators"
            v-for="collaborator in collaborators"
            :key="collaborator.slug"
            :slug="collaborator.slug"
            :name="collaborator.name"
            :summary="collaborator.summary"
            :date="collaborator.updated_at"
            :relationship="collaborator.relationship"
            :projects="collaborator.projects"
            @collaboratorHovered="handleCollaboratorHoverIn($event)"
            @collaboratorUnhovered="handleCollaboratorHoverOut($event)"
            @collaboratorClicked="handleCollaboratorClick($event)"
          />
        </ul>
      </div>
    </section>   
  </div>
</template>

<script>
import Project from './Project'
import Collaborator from './Collaborator'
import { EventBus } from '../EventBus'

export default {
  name: "ProjectsAndFriends",
  props: [
    'projects',
    'collaborators',
  ],
  components: {
    Project,
    Collaborator
  },
  data() {
    return {
      expanded: false,
      projectsTitle: 'Projects',
      collaboratorsTitle: 'Partners',
      transitionDuration: 300,
    }
  },
  created() {
  },
  mounted() {
    // if (EventBus.$root.mobile) this.transitionDuration = 0
  },
  methods: { 
    handleProjectHoverIn (project) {
      if (!EventBus.$root.mobile) {
        if (!this.somethingIsSelected()) {
          this.unHoverEverything()
          this.fadeEverything()
          project.relatedCollaborators.forEach((relatedCollaborator) => {
            relatedCollaborator.faded = false
          })
          project.faded = false
          project.hovered = true
          this.projectsTitle = "Project"
          this.collaboratorsTitle = project.relationship ? 
            project.relationship : project.collaborators.length > 0 ?    
            "Produced in collaboration with" : 
            "Produced independently."
        }
      }
    },
    handleProjectHoverOut () {
      if (!EventBus.$root.mobile) {
        if (!this.somethingIsSelected()) {
          this.unHoverEverything()
          this.unfadeEverything()
          this.projectsTitle = "Projects"
          this.collaboratorsTitle = 'Partners'
        }
      }
    },
    handleCollaboratorHoverIn (collaborator) {
      if (!EventBus.$root.mobile) {
        if (!this.somethingIsSelected()) {
          this.unHoverEverything()
          this.fadeEverything()
          collaborator.relatedProjects.forEach((relatedProject) => {
            relatedProject.faded = false
            relatedProject.hovered = true
          })
          collaborator.faded = false
          this.collaboratorsTitle = 'Partner'
          this.projectsTitle = collaborator.relationship ? 
          collaborator.relationship : collaborator.projects.length > 0 ?
            "Worked together on:" :
            "Haven't collaborated yet."
        }
      }
    },
    handleCollaboratorHoverOut () {
      if (!EventBus.$root.mobile) {
        if (!this.somethingIsSelected()) {
          this.unHoverEverything()
          this.unfadeEverything()
          this.collaboratorsTitle = 'Partners'
          this.projectsTitle = 'Projects'
        }
      }
    },
    handleProjectClick (project) {
      if (!project.selected) {
        this.$emit('childClicked', 'project')
        this.$router.push(this.$publicPath + 'projects/' + project.slug)
      } else {
        this.$router.push(this.$publicPath)
      }
    },
    handleCollaboratorClick(collaborator) {
      if (!collaborator.selected && !collaborator.hidden) {
        this.$emit('childClicked', 'collaborator')
        this.$router.push(this.$publicPath + 'collaborators/' + collaborator.slug)
      } else {
        this.$router.push(this.$publicPath)
      }
    },
    openProject(project) {
      let waitForCloseDuration = 0
      if (this.somethingIsSelected()) {
        waitForCloseDuration = this.transitionDuration
        this.unfadeinEverything()
      }
      setTimeout(() => {
        this.unselectEverything()
        this.showEverything()
        this.fadeEverything()
        if (!EventBus.$root.mobile) {
          this.expanded = true
          if (project.collaborators.length > 0) {
            project.relatedCollaborators.forEach((relatedCollaborator) => {
              relatedCollaborator.faded = false
              relatedCollaborator.selected = true
            })
          }
        }
        project.faded = false
        project.selected = true
        setTimeout(() => {
          if (!EventBus.$root.mobile) {
            if (project.collaborators.length > 0) {
              this.hideAllCollaborators()
              project.relatedCollaborators.forEach((relatedCollaborator) => {
                relatedCollaborator.hidden = false
                relatedCollaborator.fadein = true
              })
            }
            this.projectsTitle = "Project"
            this.collaboratorsTitle = project.relationship ? 
            project.relationship : project.collaborators.length > 0 ? 
            "Produced in collaboration with" : 
            "Produced independently."
          }
          project.fadein = true
          setTimeout(() => {
            this.scrollToProject(project)
          }, 100)
        }, this.transitionDuration)
      }, waitForCloseDuration)
    },
    openCollaborator(collaborator) {
      let waitForCloseDuration = 0
      if (this.somethingIsSelected()) {
        waitForCloseDuration = this.transitionDuration
        this.unfadeinEverything()
      }
      setTimeout(() => {
        this.unselectEverything()
        this.showEverything()
        this.fadeEverything()
        if (!EventBus.$root.mobile) {
          if (collaborator.projects.length > 0) {
            this.expanded = true
            collaborator.relatedProjects.forEach((relatedProject) => {
              relatedProject.faded = false
              relatedProject.selected = true
            })
          } else {
            this.expanded = false
          }
        }
        collaborator.faded = false
        collaborator.selected = true
        setTimeout(() => {
          if (!EventBus.$root.mobile) {
            if (collaborator.projects.length > 0) {
              this.hideAllProjects()
              collaborator.relatedProjects.forEach((relatedProject) => {
                relatedProject.hidden = false
                relatedProject.fadein = true
              })
            }
            this.collaboratorsTitle = 'Partner'
            this.projectsTitle = collaborator.relationship ?
            collaborator.relationship : collaborator.projects.length > 0 ?
            "Worked together on:" :
            "Haven't collaborated yet."
          }
          collaborator.fadein = true
          setTimeout(() => {
            this.scrollToCollaborator(collaborator)
          }, 100)
        }, this.transitionDuration)
      }, waitForCloseDuration)
    },
    scrollToProject(component) {
      let projectsSection = document.querySelector('#projects .content')
      let item = component.$el
      let mainHeader = EventBus.$root.mobile ? 120 : 90
      // let mainHeader = document.querySelector('p.title').offsetHeight
      let itemHeader = item.querySelector('a.name').offsetHeight
      let gap = itemHeader > mainHeader ?
                itemHeader : itemHeader + mainHeader 
      projectsSection.scroll({
        top: item.offsetTop - gap,
        behavior: 'smooth'
      })
    },
    scrollToCollaborator(component) {
      let collaboratorsSection = document.querySelector('#collaborators .content')
      let item = component.$el
      let gap = EventBus.$root.mobile ? 165 : 141
      collaboratorsSection.scroll({
        top: item.offsetTop - gap,
        behavior: 'smooth'
      })
    },
    somethingIsSelected() {
      const selectedProject = this.$refs.projects.find(p => p.selected == true)
      const selectedCollaborator = this.$refs.collaborators.find(c => c.selected == true)
      if (selectedProject || selectedCollaborator) return true
    },
    hideAllCollaborators() {
      this.$refs.collaborators.forEach(collaborator => collaborator.hidden = true)
    },
    hideAllProjects() {
      this.$refs.projects.forEach(project => project.hidden = true)
    },
    showEverything() {
      this.$refs.collaborators.forEach(collaborator => collaborator.hidden = false)
      this.$refs.projects.forEach(project => project.hidden = false)
    },
    unfadeinEverything() {
      this.$refs.projects.forEach(project => project.fadein = false)
      this.$refs.collaborators.forEach(collaborator => collaborator.fadein = false)
    },
    selectEverything() {
      this.$refs.projects.forEach(project => project.selected = true)
      this.$refs.collaborators.forEach(collaborator => collaborator.selected = true)
    },
    unselectEverything() {
      this.$refs.projects.forEach(project => project.selected = false)
      this.$refs.collaborators.forEach(collaborator => collaborator.selected = false)
    },
    fadeEverything() {
      this.$refs.projects.forEach(project => project.faded = true)
      this.$refs.collaborators.forEach(collaborator => collaborator.faded = true)
    },
    unfadeEverything() {
      this.$refs.projects.forEach(project => project.faded = false)
      this.$refs.collaborators.forEach(collaborator => collaborator.faded = false)
    },
    unHoverEverything() {
      this.$refs.projects.forEach(project => project.hovered = false)
    },
  },
}
</script>

<style scoped>

#projects-and-friends {
  border-left: var(--thin-grey);
  display: flex;  
}
#projects-and-friends.expanded #projects {
  width: 650px;
}
#projects-and-friends.expanded div.content ul:first-child {
  margin-bottom: 500px;
}
#projects-and-friends.expanded p.title {
  /* border-bottom: var(--thin-grey); */
}
</style>